
























import { computed, defineComponent } from '@vue/composition-api';
import { useGroups } from '@/store/modules/group';
import { Group } from '@/store/types';
import GroupListRow from '@/views/group/GroupListRow.vue';

export default defineComponent({
	components: {
		GroupListRow,
	},
	setup(_, { root }) {
		const { isLoading: groupsAreLoading, isLoaded: groupsAreLoaded, hasError: groupsHaveError, groupTree } = useGroups(
			root.$store
		);

		const rootGroups = computed<Group[]>(() => groupTree.value.filter((group) => group.level === 1));

		const addGroup = () => {
			root.$router.push(`/groups/new`);
		};

		return {
			rootGroups,
			addGroup,
			groupsAreLoaded,
			groupsHaveError,
			groupsAreLoading,
		};
	},
});
